import { FC } from 'react';
import { Field } from 'react-final-form';
import type { FieldValidator } from 'final-form';
import 'react-phone-number-input/style.css';
import PhoneInput, { Country } from 'react-phone-number-input';

import styles from './PhoneNumberInput.module.scss';

type CountryOption = '|' | '...' | Country;
// Sets up the preferred countries. | is just the separator between preferred and the rest.
const countryOptions: CountryOption[] = [
  'US', 'CA', 'GB', 'IT', 'DE', 'NL', 'ES', 'FR', 'HR', 'GR', '|', '...',
];

type FinalFormFieldProps = {
  validate?: FieldValidator<any>;
};

type PhoneNumberInputProps = {
  defaultCountry?: Country;
  disabled?: boolean;
  name: string;
  placeholder?: string;
  /**
   * Allows responding to for when the country changes.
   */
  onCountryChange?: (country: string | undefined) => void;
} & FinalFormFieldProps;

const PhoneNumberInput: FC<PhoneNumberInputProps> = ({
  defaultCountry = 'US',
  disabled = false,
  name,
  placeholder,
  onCountryChange,
  validate,
}) => (
  <div className={styles.phoneWrapper}>
    <Field
      name={name}
      /* An "empty" value returned by `react-phone-number-input` is always undefined, i.e.
      when the user erases the input value, onChange() is called with undefined as an argument.
      Thus, we must coerce the value to the empty string to keep it within the form state. */
      parse={(value) => value ?? ''}
      validate={validate}
    >
      {({ input }) => (
        <PhoneInput
          {...input}
          disabled={disabled}
          countryOptionsOrder={countryOptions}
          countrySelectProps={{ unicodeFlags: true }}
          defaultCountry={defaultCountry}
          placeholder={placeholder}
          onCountryChange={onCountryChange}
        />
      )}
    </Field>
  </div>
);

export default PhoneNumberInput;
